$(document).on("click", ".close_svg svg", function () {
  function getMidnightTime() {
    var midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight;
  }

  var currentTime = new Date();
  var midnightTime = getMidnightTime();
  var millisecondsCount = midnightTime.getTime() - currentTime.getTime();
  console.log(millisecondsCount);

  function setCookie(cookieName, cookieValue, millisecondsCount) {
    var d = new Date();
    d.setTime(d.getTime() + millisecondsCount);
    var expires = "expires=" + d.toUTCString();
    document.cookie =
      cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  setCookie("subscription", "true", millisecondsCount);
  var attr = $(".subscribe_section").attr("atrr_cok", true);
});

$(document).on("click", ".subscribe_section button#Subscribe", function () {
  var email = $(".main_email_check").val();
  function isValidEmail(email) {
    var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    console.log("Email: ", email);
    console.log("Pattern Test: ", pattern.test(email));
    return pattern.test(email);
  }
  if (isValidEmail(email)) {
    function getMidnightTime() {
      var midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      return midnight;
    }

    var currentTime = new Date();
    var midnightTime = getMidnightTime();
    var millisecondsCount = midnightTime.getTime() - currentTime.getTime();
    console.log(millisecondsCount);

    function setCookie(cookieName, cookieValue, millisecondsCount) {
      var d = new Date();
      d.setTime(d.getTime() + millisecondsCount);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }

    setCookie("subscription", "true", millisecondsCount);
    var attr = $(".subscribe_section").attr("atrr_cok", true);
    localStorage.setItem("check", "true");
  } else {
    event.preventDefault();
    $("#errorMessage").show();
  }
});

$(window).on("load", function () {
  function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }
  const myCookieValue = getCookie("subscription");
  if (myCookieValue == "true") {
    $(".subscribe_section").hide();
  } else {
    setTimeout(function () {
      $(".subscribe_section").show();
    }, 2000); // 2000 milliseconds = 2 seconds
  }
  var last = localStorage.getItem("check");
  if (last == "true") {
    $("body").addClass("show_pop");
  } else {
    $("body").removeClass("show_pop");
  }
});
